import React from 'react';
import { WithSearch } from '@elastic/react-search-ui';
import JobCardList from './JobCardList';
import { JobResult } from '../types/job';

export const ElasticResultsWrapper: React.FC = () => (
    <WithSearch mapContextToProps={({ results, isLoading }) => ({ results, isLoading })}>
      {({ results, isLoading }: { results: JobResult[]; isLoading: boolean }) => {
        if (isLoading) return <p>Loading jobs…</p>;
        if (!results || results.length === 0) return <p>No jobs found.</p>;
        return <JobCardList results={results} />;
      }}
    </WithSearch>
);
